<template>
  <v-data-table :headers="headers"
                :items="payments"
                item-key="nr"
                class="mt-4"
                hide-default-footer
                :items-per-page="-1"
                :mobile-breakpoint="0">
    <template #item.paymentDate="{ item }">
      {{ item.paymentDate | formatDate }}
    </template>
    <template #item.bookingDate="{ item }">
      {{ item.bookingDate | formatDate }}
    </template>
    <template #item.amount="{ item }">
      {{ item.amount | currency }}
    </template>
  </v-data-table>
</template>

<script>
  export default {
    props: ['payments'],
    computed: {
      headers () {
        return [
          { text: this.$t('paymentDate'), value: 'paymentDate' },
          { text: this.$t('registered'), value: 'bookingDate' },
          { text: this.$t('sum'), value: 'amount' }
        ]
      }
    }
  }
</script>
